module.exports = __webpack_public_path__ + "img/Group_2888.97330bb3.svg";